(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mf-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mf-back-to-top')) {
    customElements.define(
      'mf-back-to-top',
      class MfBackToTop extends HTMLElement {
        connectedCallback() {
          if (this.isInitialized) return;

          this.button = this.querySelector('.mf-back-to-top__button');
          if (!this.button) return;

          this.isInitialized = true;
          this.frame = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.updateVisibility = this.updateVisibility.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleClick = this.handleClick.bind(this);

          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.button.addEventListener('click', this.handleClick);
          this.updateVisibility();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.handleScroll);
          this.button?.removeEventListener('click', this.handleClick);

          if (this.frame) {
            cancelAnimationFrame(this.frame);
          }
        }

        handleScroll() {
          if (this.frame) return;

          this.frame = requestAnimationFrame(() => {
            this.updateVisibility();
            this.frame = null;
          });
        }

        updateVisibility() {
          const isVisible = window.scrollY > 400;
          this.button.classList.toggle('is-visible', isVisible);
          this.button.setAttribute('aria-hidden', String(!isVisible));
          this.button.tabIndex = isVisible ? 0 : -1;
        }

        handleClick() {
          window.scrollTo({
            top: 0,
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
